import React from 'react';
import { Flame } from 'lucide-react';

export default function Footer({ isDark }) {
  return (
    <footer
      className={`${
        isDark ? 'bg-gray-900' : 'bg-gradient-to-r from-orange-600 to-rose-600'
      } text-white py-12`}
    >
      <div className='max-w-7xl mx-auto px-4 text-center'>
        <div className='flex items-center justify-center space-x-3 mb-6'>
          <div className='w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center'>
            <Flame className='w-6 h-6 text-white animate-pulse' />
          </div>
          <div>
            <h3 className='text-xl font-bold'>Свічкова Майстерня</h3>
            <p className='text-white/80 text-sm'>Створюємо магію затишку</p>
          </div>
        </div>
        <p className='text-white/80 mb-4'>
          © 2025 Свічкова Майстерня. Всі права захищені.
        </p>
        <p className='text-white/60'>
          Створено з ❤️ для любителів унікальних свічок
        </p>
      </div>
    </footer>
  );
}
